import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CALL_STATUS } from "./constants";
import mediaAPI from "../../api/media";
import { deleteMedia, blockMedia, unblockMedia, blockUser } from "./media.reducer";

const initialState = {
	status: CALL_STATUS.IDLE,
	error: null,
	data: []
}

export const getMyMedia = createAsyncThunk('media/GET_MY_MEDIA', async (token) => {
	const response = await mediaAPI.getMyMedia(token);
	return response;
}
);

const myMediaSlice = createSlice({
	name: "my_media",
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(getMyMedia.pending, (state, action) => {
				state.status = CALL_STATUS.PENDING;
				state.error = null;
			})
			.addCase(getMyMedia.fulfilled, (state, action) => {
				state.status = CALL_STATUS.SUCCESS;
				state.error = null;
				state.data = action.payload.data;
			})
			.addCase(getMyMedia.rejected, (state, action) => {
				state.status = CALL_STATUS.ERROR;
				state.error = null;
			})
			.addCase(deleteMedia.fulfilled, (state, action) => {
				if (state.data) {
					state.data = state.data.filter(item => item.id !== action.payload);
				}
			})
			.addCase(blockMedia.fulfilled, (state, action) => {
				const media = state.data.find(item => item.id === action.payload);
				if (media) {
					media.status = 'BLOCKED';
				}
			})
			.addCase(unblockMedia.fulfilled, (state, action) => {
				const media = state.data.find(item => item.id === action.payload);
				if (media) {
					media.status = 'HISTORY';
				}
			})
			.addCase(blockUser.fulfilled, (state, action) => {
				if (action.meta.arg.blockVideos) {
					if (state.data) {
						const userId = action.payload;
						state.data = state.data.filter(media => media.ownerId !== userId);
					}
				}
			});
	}
});

const { actions, reducer } = myMediaSlice;

export const {
	reset
} = actions;

export default reducer;